import React from 'react'
import { Box } from '@material-ui/core'

export default function ErrorPage() {
  return <Box>Please access this page through your mobile app!</Box>
}
